import ExtensionIcon from "@mui/icons-material/Extension";
import StorageIcon from "@mui/icons-material/Storage";
import LeakAddIcon from "@mui/icons-material/LeakAdd";
import EngineeringIcon from "@mui/icons-material/Engineering";

export const serviceData = [
  {
    child: <ExtensionIcon className="text-[cyan] !text-[35px]" />,
    title: "Full Stack Development",
    description:
      "Building scalable web applications using React, Next.js, Node.js, and TypeScript from concept to production.",
    btnText: "Learn More",
  },
  {
    child: <LeakAddIcon className="text-[cyan] !text-[35px]" />,
    title: "Backend Engineering",
    description:
      "Designing secure, scalable APIs, authentication systems, databases, and business logic for modern applications.",
    btnText: "Learn More",
  },
  {
    child: <StorageIcon className="text-[cyan] !text-[35px]" />,
    title: "Cloud & DevOps",
    description:
      "Deploying and maintaining production applications with Docker, AWS, Nginx, CI/CD, and cloud infrastructure.",
    btnText: "Learn More",
  },
  {
    child: <EngineeringIcon className="text-[cyan] !text-[35px]" />,
    title: "Performance & Architecture",
    description:
      "Improving application performance, maintainability, scalability, and overall software architecture.",
    btnText: "Learn More",
  },
];